import { AccessInfo } from 'domain/shared/newProject';

export interface ProjectAssumptionResponse {
  baseProject: {
    id: string | number;
    assumptions: AssumptionType[];
    accessInfo?: AccessInfo;
  };
}

export const ASSUMPTION_STATUS = {
  VALID: 'VALID',
  VIOLATED: 'VIOLATED',
  INACTIVE: 'RESOLVED',
} as const;
export const ASSUMPTION_EXCEPTION_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;

export type AssumptionExceptionStatus = (typeof ASSUMPTION_EXCEPTION_STATUS)[keyof typeof ASSUMPTION_EXCEPTION_STATUS];

export type AssumptionType = {
  id: string;
  projectId?: string;
  number?: number;
  description: string;
  assignedRole: string;
  status?: string;
  isVerificationRequired?: boolean;
  exceptionStatus?: AssumptionExceptionStatus | null;
  exceptionReason?: string | null;
  exceptionUntilDate?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  createdBy?: string;
  updatedBy?: string;
};

export type AssumptionFormValues = {
  description: string;
  assignedRole: string | null;
  status: string;
  requestException?: boolean;
  exceptionReason?: string;
  exceptionUntilDate?: string;
};

export type AssumptionExceptionPayload = {
  exceptionStatus?: AssumptionExceptionStatus;
  exceptionReason?: string;
  exceptionUntilDate?: string;
};

export type AssumptionCreatePayload = {
  projectId: string;
  description: string;
  assignedRole: string | null;
  status: string;
  createdBy?: string;
} & AssumptionExceptionPayload;

export type AssumptionUpdatePayload = {
  id: string;
  description: string;
  assignedRole: string | null;
  status: string;
  updatedBy?: string;
} & AssumptionExceptionPayload;
